import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class InsoleModelGabaritShoeSizeSummaryModel implements SummaryModel{
    id: number;
    permissions: PermissionsModel;
    gabarit: LovValueSummary;
    shoeSize: LovValueSummary;
}